import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setQrCode } from "../redux/slices/qrSlice";
import { useTranslation } from "react-i18next";
import i18n from "i18next";

const Language = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { code } = useParams();

  const [selectedLang, setSelectedLang] = useState("hi");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const languages = [
    { label: "हिंदी", value: "hi" },
    { label: "English", value: "en" },
  ];

  useEffect(() => {
    const savedLang = localStorage.getItem("appLanguage");
    if (savedLang) {
      setSelectedLang(savedLang);
      i18n.changeLanguage(savedLang);
    } else {
      i18n.changeLanguage("hi");
      localStorage.setItem("appLanguage", "hi");
    }
  }, []);

  useEffect(() => {
    if (code) {
      dispatch(setQrCode(code));
      localStorage.setItem("qrCode", code);
    }
  }, [code, dispatch]);

  const handleLanguageChange = (lang) => {
    setSelectedLang(lang);
    i18n.changeLanguage(lang);
    localStorage.setItem("appLanguage", lang);
    setDropdownOpen(false);
  };

  const handleContinue = () => {
    navigate("/login");
  };

  const selectedLabel = languages.find((l) => l.value === selectedLang)?.label;

  return (
    <div
      className="h-screen bg-white md:bg-[#F5F6FA] md:flex md:justify-center md:items-start"
      onClick={() => setDropdownOpen(false)}
    >
      <div className="w-full max-w-md mx-auto md:bg-white md:rounded-3xl md:shadow-lg md:px-6 md:py-8 flex flex-col">

        {/* Top bar — dropdown top right */}
        <div className="flex justify-end px-4 pt-4 relative">
          <div className="relative" onClick={(e) => e.stopPropagation()}>
            <button
              onClick={() => setDropdownOpen((prev) => !prev)}
              className="flex items-center gap-2 px-3 py-2 rounded-xl border border-gray-200 text-sm font-medium text-gray-700 bg-white"
            >
               {selectedLabel}
              <span className={`transition-transform duration-200 ${dropdownOpen ? "rotate-180" : ""}`}>
                ▾
              </span>
            </button>

            {dropdownOpen && (
              <div className="absolute right-0 top-full mt-1 bg-white border border-gray-200 rounded-xl shadow-md z-10 min-w-[130px]">
                {languages.map((lang) => (
                  <button
                    key={lang.value}
                    onClick={() => handleLanguageChange(lang.value)}
                    className={`w-full text-left px-4 py-2.5 text-sm flex items-center justify-between hover:bg-gray-50 ${
                      selectedLang === lang.value ? "font-semibold text-[#1A1F36]" : "text-gray-600"
                    }`}
                  >
                    {lang.label}
                    {selectedLang === lang.value && <span>✓</span>}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Logo */}
        <div className="text-center mt-2 mb-4 leading-tight w-50 mx-auto">
          <h1 className="text-2xl font-bold text-gray-800">{t("app.title")}</h1>
          <p className="text-xl font-semibold mt-2 mb-8 text-gray-800">{t("app.subtitle")}</p>
        </div>

        <div className="px-4 flex-1 overflow-y-auto">
          {/* Banner */}
          <img src="/updated_banner.jpg" alt="banner" className="w-full mb-6 md:rounded-2xl" />

        

          {/* Continue Button */}
          <button
            onClick={handleContinue}
            className="w-full text-white py-3 rounded-xl font-semibold"
            style={{ backgroundColor: "#1A1F36" }}
          >
            {t("common.continue")}
          </button>
        </div>
      </div>
    </div>
  );
};
export default Language;